import React from "react";

const VerifyFromFile = () => {
  return (
    <svg
      height="28"
      viewBox="0 0 28 28"
      width="28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m1.2 28a1.193 1.193 0 0 1 -1.2-1.2v-20.392a1.276 1.276 0 0 1 1.275-1.274h2.458v-5.134h11.393l3.638 3.637 3.4 3.4.231.231v1.132h1.525a1.277 1.277 0 0 1 1.28 1.275v2.925h1.629a1.25 1.25 0 0 1 1.171 1.387v.083l-4.772 13.084a1.185 1.185 0 0 1 -1.144.846zm-.269-1.228a.272.272 0 0 0 .266.294h20.887a.263.263 0 0 0 .255-.194l4.724-12.956c-.012-.128-.057-.382-.234-.382h-20.888a.264.264 0 0 0 -.254.194l-.013.039-1.941 5.321zm0-20.364v17.578l2.8-7.637v-10.282h-2.456a.342.342 0 0 0 -.342.341zm3.736-1.274v8.672l.131-.36a1.175 1.175 0 0 1 .946-.83 1.2 1.2 0 0 1 .2-.016h15.523v-4.666h-7v-7h-9.8zm17.733 7.466h1.867v-2.925a.342.342 0 0 0 -.342-.342h-1.525zm-7-5.6h5.407l-5.407-5.406zm-7.934 3.2a.467.467 0 0 1 0-.933h11.2a.467.467 0 0 1 0 .933zm0-3.266a.467.467 0 0 1 0-.933h4.667a.467.467 0 1 1 0 .933zm0-3.267a.467.467 0 0 1 0-.933h4.667a.467.467 0 1 1 0 .933z" />
    </svg>
  );
};

export default VerifyFromFile;
